module.exports = __webpack_public_path__ + "static/media/text.39faf28b.svg";